const debug = false;

const AppConfig = {
  app_name: "Laddar Web App",
  business_name: "Laddar Africa",
  business_website: "https://laddar.africa",
  api_base_url: debug ? "http://127.0.0.1:8000/v1/" : "https://api.laddar.africa/v1/",
  api_media_url: debug ? "http://127.0.0.1:8000/media/" : "https://api.laddar.africa/media/",
  app_version_store: "_ldr_web_version_",
  session_storage_label: "_ldr_ws_session_",
  cart_storage_label: "_ldr_ws_checkout_",
  product_cart_storage_label: "_ldr_ws_product_cart_",
  google_map_key: "AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0",
};

export default AppConfig;
